module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/remittance-entry/check-detail/check-detail.component.css
// module id = ./src/app/components/remittance-entry/check-detail/check-detail.component.css
// module chunks = main